import { Controller } from '@hotwired/stimulus'

const STORAGE_KEY = 'dismissedSubscriptionBanners'

export default class extends Controller {
  static values = { key: String }

  connect() {
    if (this.hasKeyValue && this.#dismissedKeys().includes(this.keyValue)) {
      this.element.remove()
    }
  }

  dismiss() {
    if (this.hasKeyValue) {
      const keys = this.#dismissedKeys()
      if (!keys.includes(this.keyValue)) {
        keys.push(this.keyValue)
        localStorage.setItem(STORAGE_KEY, JSON.stringify(keys))
      }
    }

    this.element.remove()
  }

  #dismissedKeys() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []
    } catch {
      return []
    }
  }
}
